/** This is a syntactic sugar for `rows` prop. So HOC will not work on this. */
// tslint:disable-next-line:function-name
function Row(_) {
  return null;
}

export default Row;